import React, { useState, useRef } from 'react';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonPage,
  IonButtons,
  IonMenuButton,
  IonList,
  IonListHeader,
  IonItem,
  IonAlert,
  IonLabel,
  IonButton,
  IonToast
} from '@ionic/react';
import { checkmarkDoneCircle, warning } from 'ionicons/icons';
import './Account.scss';
import { setUsername } from '../data/user/user.actions';
import { connect } from '../data/connect';
import { RouteComponentProps } from 'react-router';
import axiosInstance from '../data/axios/axiosInstance';
import { Shipment } from '../models/Shipment';
import { Inspection } from '../models/Inspection';
import { Shipping } from '../models/Shipping';
import { Store } from '../models/Store';

interface OwnProps extends RouteComponentProps {}

interface StateProps {
  username?: string;
}

interface DispatchProps {
  setUsername: typeof setUsername;
}

interface AccountProps extends OwnProps, StateProps, DispatchProps {}

const Account: React.FC<AccountProps> = ({ setUsername, username }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [showPassAlert, setShowPassAlert] = useState(false);

  const [showResultToast, setShowResultToast] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [resultIcon, setResultIcon] = useState(checkmarkDoneCircle);

  const clicked = (text: string) => {
    console.log(`Clicked ${text}`);
  };

  const fileShipmentRef = useRef<HTMLInputElement | null>(null);
  const fileInspectionRef = useRef<HTMLInputElement | null>(null);
  const fileShippingRef = useRef<HTMLInputElement | null>(null);

  const onClickShipment = () => {
    if (fileShipmentRef.current) {
      fileShipmentRef.current.click();
    }
  };

  const onClickInspection = () => {
    if (fileInspectionRef.current) {
      fileInspectionRef.current.click();
    }
  };

  const onClickShipping = () => {
    if (fileShippingRef.current) {
      fileShippingRef.current.click();
    }
  };

  const onUploadShipment = async (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.files)
    if (event.target.files && event.target.files.length > 0) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      try {
        const response = await axiosInstance.post('/upload_shipment', formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
        });

        if ( response.status === 200 ) {
          setResultMessage('正常にアップロードされました。');
          setShowResultToast(true);
          setResultIcon(checkmarkDoneCircle);
        } else {
          setResultMessage('アップロード中にエラーが発生しました。');
          setShowResultToast(true);
          setResultIcon(warning);
        }
      } catch (error) {
        setResultMessage('アップロード中にエラーが発生しました。');
        setShowResultToast(true);
        setResultIcon(warning);
      }

      if (fileShipmentRef.current)
        fileShipmentRef.current.value = "";
    }
  };

  const onUploadInspection = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      try {
        const response = await axiosInstance.post('/upload_inspection', formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
        });

        if ( response.status === 200 ) {
          setResultMessage('正常にアップロードされました。');
          setShowResultToast(true);
          setResultIcon(checkmarkDoneCircle);
        } else {
          setResultMessage('アップロード中にエラーが発生しました。');
          setShowResultToast(true);
          setResultIcon(warning);
        }
      } catch (error) {
        setResultMessage('アップロード中にエラーが発生しました。');
        setShowResultToast(true);
        setResultIcon(warning);
      }

      if (fileInspectionRef.current)
        fileInspectionRef.current.value = "";
    }
  };

  const onUploadShipping = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      try {
        const response = await axiosInstance.post('/upload_shipping', formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
        });
        
        if ( response.status === 200 ) {
          setResultMessage('正常にアップロードされました。');
          setShowResultToast(true);
          setResultIcon(checkmarkDoneCircle);
        } else {
          setResultMessage('アップロード中にエラーが発生しました。');
          setShowResultToast(true);
          setResultIcon(warning);
        }
      } catch (error) {
        setResultMessage('アップロード中にエラーが発生しました。');
        setShowResultToast(true);
        setResultIcon(warning);
      }

      if (fileShippingRef.current)
        fileShippingRef.current.value = "";
    }
  };

  const onClickShipmentDownload = async () => {
    try {
      const response = await axiosInstance.get('/shipments_download');
      if (response.status === 200 && response.data.shipments && response.data.shipments.length > 0) {
        const csvString = [
          ["jan", "original_num", "rack_num", "out_quantity", "order_num", "image", "user", "time"],
          ...response.data.shipments.map((item: Shipment) => [
            item.jan,
            item.original_num,
            item.rack_num,
            item.quantity,
            item.order_num,
            item.image,
            item.user?.name || '',
            new Date(item.updated_at).toLocaleString('ja-JP', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            })
          ])
        ]
        .map(row => row.join(","))
        .join("\n");
    
        const blob = new Blob([csvString], { type: 'text/csv' });
    
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '出庫完了マスタ.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setResultMessage('正常にダウンロードされました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      } else {
        setResultMessage('ダウンロードのデータが存在しません。');
        setShowResultToast(true);
        setResultIcon(warning);
      }
    } catch (error) {
      setResultMessage('ダウンロード中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickInspectionDownload = async () => {
    try {
      const response = await axiosInstance.get('/inspections_download');
      if (response.status === 200 && response.data.inspections && response.data.inspections.length > 0) {
        const csvString = [
          ["jan", "original_num", "order_date", "quantity", "order_num", "image", "user", "time"],
          ...response.data.inspections.map((item : Inspection) => [item.jan, item.original_num, item.order_date, item.quantity, item.order_num, item.image, item.user?.name, 
            new Date(item.updated_at).toLocaleString('ja-JP', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
          })])
        ]
        .map(row => row.join(","))
        .join("\n");
    
        const blob = new Blob([csvString], { type: 'text/csv' });
    
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '検品完了マスタ.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setResultMessage('正常にダウンロードされました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      } else {
        setResultMessage('ダウンロードのデータが存在しません。');
        setShowResultToast(true);
        setResultIcon(warning);
      }
    } catch (error) {
      setResultMessage('ダウンロード中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickShippingDownload = async () => {
    try {
      const response = await axiosInstance.get('/shippings_download');
      if (response.status === 200 && response.data.shippings && response.data.shippings.length > 0) {
        const csvString = [
          ["jan", "original_num", "order_date", "order_num", "rack_num", "shipping_num", "image", "user", "time"],
          ...response.data.shippings.map((item : Shipping) => ["\"" + item.jan + "\"", item.original_num, item.order_date, item.order_num, item.rack_num, item.shipping_num, item.image, item.user?.name, 
            new Date(item.updated_at).toLocaleString('ja-JP', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
          })
          ])
        ]
        .map(row => row.join(","))
        .join("\n");
    
        const blob = new Blob([csvString], { type: 'text/csv' });
    
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '出荷完了マスタ.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setResultMessage('正常にダウンロードされました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      } else {
        setResultMessage('ダウンロードのデータが存在しません。');
        setShowResultToast(true);
        setResultIcon(warning);
      }
    } catch (error) {
      setResultMessage('ダウンロード中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickStoreDownload = async () => {
    try {
      const response = await axiosInstance.get('/stores_download');
      if (response.status === 200 && response.data.stores && response.data.stores.length > 0) {
        const csvString = [
          ["JAN or OGN", "quantity", "rack_num", "user", "time"],
          ...response.data.stores.map((item : Store) => ["\"" + item.jan + "\"", item.quantity, item.rack_num, item.user?.name, 
            new Date(item.updated_at).toLocaleString('ja-JP', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
          })])
        ]
        .map(row => row.join(","))
        .join("\n");
    
        const blob = new Blob([csvString], { type: 'text/csv' });
    
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '入庫完了マスタ.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setResultMessage('正常にダウンロードされました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      } else {
        setResultMessage('ダウンロードのデータが存在しません。');
        setShowResultToast(true);
        setResultIcon(warning);
      }
    } catch (error) {
      setResultMessage('ダウンロード中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickShipmentRemove = async () => {
    try {
      const response = await axiosInstance.get('/shipments_remove');
      if (response.status === 200 && response.data.shipments > 0) {
        setResultMessage('正常に削除されました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      }
    } catch (error) {
      setResultMessage('削除中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickInspectionRemove = async () => {
    try {
      const response = await axiosInstance.get('/inspections_remove');
      if (response.status === 200 && response.data.inspections > 0) {
        setResultMessage('正常に削除されました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      }
    } catch (error) {
      setResultMessage('削除中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  const onClickShippingRemove = async () => {
    try {
      const response = await axiosInstance.get('/shippings_remove');
      if (response.status === 200 && response.data.shippings > 0) {
        setResultMessage('正常に削除されました。');
        setShowResultToast(true);
        setResultIcon(checkmarkDoneCircle);
      }
    } catch (error) {
      setResultMessage('削除中にエラーが発生しました。');
      setShowResultToast(true);
      setResultIcon(warning);
    }
  };

  return (
    <IonPage id="account-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>アカウント</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {username && (
          <div className="ion-padding-top ion-text-center">
            <img
              src="assets/icon/favicon.png"
              alt="avatar"
            />
            <h2>{username}</h2>
            <IonList inset>
              <IonListHeader>
                <IonLabel slot='start'>プロファイル</IonLabel>
              </IonListHeader>
              <IonItem onClick={() => clicked('Update Picture')}>
                画像変更
              </IonItem>
              <IonItem onClick={() => setShowAlert(true)}>
                ユーザー名変更
              </IonItem>
              <IonItem onClick={() => setShowPassAlert(true)}>
                パスワード変更
              </IonItem>
              <IonItem routerLink="/logout" routerDirection="none">
                サインアウト
              </IonItem>
            </IonList>

            <IonList inset>
              <IonItem>
                入庫マスタ
                <IonButton color="primary" expand="full" onClick={() => onClickStoreDownload()} slot='end'>
                  ダウンロード
                </IonButton>
              </IonItem>
              <IonItem>
                出庫マスタ
                <input type="file" accept=".csv" onChange={onUploadShipment} ref={fileShipmentRef} style={{ display: 'none' }} />
                <IonButton color="primary" expand="full" onClick={() => onClickShipment()} slot='end'>
                  アップロード
                </IonButton>
                <IonButton color="primary" expand="full" onClick={() => onClickShipmentDownload()} slot='end'>
                  ダウンロード
                </IonButton>
              </IonItem>
              <IonItem>
                <IonButton color="primary" expand="full" onClick={() => onClickShipmentRemove()} slot='end'>
                アップロードデータの削除
                </IonButton>
              </IonItem>
              <IonItem>
                検品マスタ
                <input type="file" accept=".csv" onChange={onUploadInspection} ref={fileInspectionRef} style={{ display: 'none' }} />
                <IonButton color="primary" expand="full" onClick={() => onClickInspection()} slot='end'>
                  アップロード
                </IonButton>
                <IonButton color="primary" expand="full" onClick={() => onClickInspectionDownload()} slot='end'>
                  ダウンロード
                </IonButton>
              </IonItem>
              <IonItem>
                <IonButton color="primary" expand="full" onClick={() => onClickInspectionRemove()} slot='end'>
                アップロードデータの削除
                </IonButton>
              </IonItem>
              <IonItem>
                出荷マスタ
                <input type="file" accept=".csv" onChange={onUploadShipping} ref={fileShippingRef} style={{ display: 'none' }} />
                <IonButton color="primary" expand="full" onClick={() => onClickShipping()} slot='end'>
                  アップロード
                </IonButton>
                <IonButton color="primary" expand="full" onClick={() => onClickShippingDownload()} slot='end'>
                  ダウンロード
                </IonButton>
              </IonItem>
              <IonItem>
                <IonButton color="primary" expand="full" onClick={() => onClickShippingRemove()} slot='end'>
                アップロードデータの削除
                </IonButton>
              </IonItem>
            </IonList>
          </div>
        )}
        <IonToast
          isOpen={showResultToast}
          onDidDismiss={() => setShowResultToast(false)}
          message={resultMessage}
          duration={2000}
          position="bottom"
          icon={resultIcon}
        />
      </IonContent>
      <IonAlert
        isOpen={showAlert}
        header="ユーザー名変更"
        buttons={[
          'キャンセル',
          {
            text: '確認',
            handler: async(data) => {
              try {
                const response = await axiosInstance.post('/username', { username: data.username,});
                if (response.status === 200) {
                  setUsername(data.username);
                  setResultMessage('正常に変更されました。');
                  setShowResultToast(true);
                  setResultIcon(checkmarkDoneCircle);
                }
              } catch (error) {
                setResultMessage('変更中にエラーが発生しました。');
                setShowResultToast(true);
                setResultIcon(warning);
              }
            },
          },
        ]}
        inputs={[
          {
            type: 'text',
            name: 'username',
            value: username,
            placeholder: 'username',
          },
        ]}
        onDidDismiss={() => setShowAlert(false)}
      />
      <IonAlert
        isOpen={showPassAlert}
        header="パスワード変更"
        buttons={[
          'キャンセル',
          {
            text: '確認',
            handler: async(data) => {
              if (data.newPassword !== data.confirmPassword) {
                setResultMessage('新しいパスワードが一致しません。');
                setResultIcon(warning);
                setShowResultToast(true);
                return;
              }
              
              try {
                const response = await axiosInstance.post('/password', {
                  password: data.newPassword,
                });
                if (response.status === 200) {
                  setResultMessage('パスワードが正常に変更されました。');
                  setResultIcon(checkmarkDoneCircle);
                  setShowResultToast(true);
                }
              } catch (error) {
                setResultMessage('パスワード変更中にエラーが発生しました。');
                setResultIcon(warning);
                setShowResultToast(true);
              }
            },
          },
        ]}
        inputs={[
          {
            type: 'password',
            name: 'newPassword',
            placeholder: '新しいパスワード',
          },
          {
            type: 'password',
            name: 'confirmPassword',
            placeholder: '新しいパスワードの確認',
          },
        ]}
        onDidDismiss={() => setShowPassAlert(false)}
      />
    </IonPage>
  );
};

export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state) => ({
    username: state.user.username,
  }),
  mapDispatchToProps: {
    setUsername,
  },
  component: Account,
});
